var _rect, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#E5FBEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 36,
    r: 15,
    fill: "#03C302"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.001,
    cy: 36.0014,
    r: 15,
    transform: "rotate(9.8144 36.001 36.0014)",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 36.75L33.75 39.75L41.25 32.25",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessv2);
export default __webpack_public_path__ + "static/media/successv2.a58721f6a7787c248426f44e928f4d52.svg";
export { ForwardRef as ReactComponent };